import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import 'react-simple-keyboard/build/css/index.css';
import Styles from '../orders.module.scss';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { TouchableDiv, TouchableButton } from '@components/common/Touchable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setErrorPopUp } from '@reducers/notification';

const openPopUp = ({
  onSubmit,
  validate,
  isOpen,
  selected,
  setIsOpenPopUp,
  isOpenPopUp,
  discounts,
  serverAppTheme,
  setSelected,
  setErrorPopUp,
  orderingPortraitOrientation
}) => {
  const [keyboardType, setKeyboardType] = useState('withoutDone');
  const ref = useRef(null);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const [inputName, setInputName] = useState('discount');
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [typed, setTyped] = useState({});
  const symbol = discounts?.find((e) => e.id === Number(selected))?.discountType === 1 ? `${LABEL().CURRENCY_SYMBOL}` : '%'

  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;

  const setEmpty = useCallback((data) => {
    setTyped(prev => ({ ...prev, [data]: '' }));
    setInputs(prev => ({ ...prev, [data]: '' }));
  }, []);
  useEffect(() => {
    if (ref.current) {
      setInputs(prev => ({ ...prev, 'phoneNumber': '' }));
      setTyped(prev => ({ ...prev, 'phoneNumber': '' }));
    }
  }, []);

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat] || '');
  };

  const handleSubmit = () => {
    const data = {
      ...inputs
    };
    validate(data).then(() => {
      setIsOpenPopUp(!isOpenPopUp);
      onSubmit(data);
    }).catch((err) => {
      setErrorPopUp({
        res: err.message,
        noErrorTxt: true,
      });
    });
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const discount = document.querySelector('#discount');
    discount.blur();
  };
  useEffect(() => {
    setInputs(prev => ({ ...prev, [inputName]: prev[inputName] }));
    if (ref.current) {
      ref.current.input = {
        ...inputs,
        [inputName]: inputs[inputName]
      };
    }
  }, [isSwipedDown]);

  const getStyle = () => {
    return discounts.find((e) => e.id === Number(selected))?.discountType === 1 ? Styles.currencyDollar : Styles.currencyPercent;
  };

  const onClickBtn = useCallback((e) => {
    setError('');
    const currentInputName = inputNameRef.current;
    let rawNewValue;

    setTyped(prev => {
      const newValue = e === '{bksp}'
        ? { ...prev, [currentInputName]: prev[currentInputName]?.slice(0, -1) }
        : { ...prev, [currentInputName]: prev[currentInputName] ? prev[currentInputName].concat(e) : ''.concat(e) };
      rawNewValue = newValue[currentInputName];
      return newValue;
    });

    setInputs(prev => ({
      ...prev,
      [currentInputName]: rawNewValue,
    }));
  }, []);

  const keyboardCustomClass = useMemo(() => cn('fs-36 fw-600 p-2', Styles.keys), [Styles.keys]);

  return isOpen && (
    <div style={{ paddingTop: inputName !== 'discount' && '1rem' ,top : orderingPortraitOrientation ? '30%' : '' , left: orderingPortraitOrientation ? '0px' : '' ,right : orderingPortraitOrientation ? '0px' : '' }} className={cn('h-90', orderingPortraitOrientation ? 'position-absolute px-3' : '')}>
      <div className={cn(" mx-auto large-input" ,orderingPortraitOrientation ? 'col-12 px-0' : 'col-7 p-0')} >
        <div className={cn('col-12 p-0 m-auto d-flex align-items-center')}>
          <div
            style={{ color: serverAppTheme?.primary_text }}
            className={cn('position-absolute', getStyle())}
          >
            {symbol}
          </div>
          <input
            id="discount"
            type="text"
            name="discount"
            value={getInputValue('discount')}
            className={cn('w-100 pr-20', orderingPortraitOrientation ? 'fs_24 pt-1' : 'fs_32', Styles.discountInput)}
            placeholder={LABEL().DISCOUNT}
            onFocus={() => { handleBlur(); setInputName('discount'); }}
            style={{ background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder, }}
          />
          {inputs?.discount?.length > 0 && (
            <TouchableDiv
              role="presentation"
              className="position-absolute"
              style={{ right: '10px' }}
              onClick={(e) => { e.preventDefault(); setEmpty('discount'); setInputName('discount'); }}
            >
              <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" />
            </TouchableDiv>
          )}
        </div>
        {error.length > 0 && <div className="col-12 fs-12 p-0 position-absolute text-primary text-right">{error}</div>}
        <div className={cn('col-12 mx-auto px-0 pt-4', inputName !== 'discount' && 'pt-2')}>
          {isSwipedDown && (
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={onClickBtn}
              type={keyboardType}
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn35"
              isDot
              isDiscount
              customClass={keyboardCustomClass}
            />
          )}
        </div>
      </div>
      <div 
        className={cn('mx-auto d-flex', orderingPortraitOrientation ?'col-12 fixed-bottom pb-3' :'col-8')}
        style={{paddingTop: "14px"}}
      >
        <div className={cn("col-6", inputName !== 'discount' && 'pt-3' ,orderingPortraitOrientation ? 'pl-0 pr-0' : 'pr-1')}>
          <TouchableButton type="button" className={cn('px-0  rounded btn-ripple fs_24 fw-600 w-100' ,orderingPortraitOrientation ? 'btn68' : 'bnt44')} onClick={() => { setIsOpenPopUp(!isOpenPopUp); setEmpty('discount'); setError(''); setSelected('') }} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font}} rippleEffect={true}>
            {LABEL().CANCEL}
          </TouchableButton>
        </div>
        <div className={cn("col-6", inputName !== 'discount' && 'pt-3' ,orderingPortraitOrientation ?'pr-0 pl-2':'pl-1')}>
          <TouchableButton disabled={!selected} className={cn("w-100 d-flex justify-content-center align-items-center rounded btn-ripple  text-white", orderingPortraitOrientation ? 'btn68' : 'btn44')} style={{ background: '#2541A4'}} type="button" onClick={(e) => { e.preventDefault(); handleSubmit(); }} rippleEffect={true}>
            <div>{LABEL().APPLY}</div>
          </TouchableButton>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setErrorPopUp
}, dispatch);

const MemoizedOpenPopUp = React.memo(openPopUp);

export default connect(
  null,
  mapDispatchToProps
)(MemoizedOpenPopUp);
